import { AccessIssueFacets } from '@acp/shared';

export const facetCategories = [
    {
        label: 'Service status',
        description: '',
        value: 'SERVICE_STATUS',
        applicableStates: null,
    },
    {
        label: 'Access escalation level',
        description: '',
        value: 'ACCESS_ESCALATION_LEVEL',
        applicableStates: null,
    },
];

export const facetOptions = [
    {
        label: 'Overdue',
        description: '',
        value: AccessIssueFacets.Overdue,
        category: 'SERVICE_STATUS',
        applicableStates: null,
    },
    {
        label: 'Not overdue',
        description: '',
        value: AccessIssueFacets.NotOverdue,
        category: 'SERVICE_STATUS',
        applicableStates: null,
    },
    {
        label: 'Priority booking',
        description: '',
        value: AccessIssueFacets.PriorityBooking,
        applicableStates: null,
    },
    {
        label: 'Vacant',
        description: '',
        value: AccessIssueFacets.Vacant,
        applicableStates: null,
    },
    {
        label: 'Services on hold',
        description: 'Enrolments are on hold',
        value: AccessIssueFacets.OnHold,
        applicableStates: null,
    },
    {
        label: 'Suspension warning',
        description: '',
        value: AccessIssueFacets.SuspensionWarning,
        category: 'ACCESS_ESCALATION_LEVEL',
        applicableStates: null,
    },
    {
        label: 'Suspended',
        description: '',
        value: AccessIssueFacets.Suspended,
        category: 'ACCESS_ESCALATION_LEVEL',
        applicableStates: null,
    },
];
